export const CaseDocumentType = Object.freeze({
  forApplication: 'for-application',
  forCreditReview: 'for-credit-review',
});
